<div *transloco="let t" class="sms-sign-in-component">
  <nav class="dialog-head">
    <button
      class="popsy-button-icon button"
      [class.rtl]="isRtlLayout()"
      (click)="changeDialogMode('auth-intro')">
      <popsy-icon-arrow-left-1
        class="icon gray-dark"
        aria-hidden="true"></popsy-icon-arrow-left-1>
    </button>
    <div aria-hidden="true" class="dynamic-space"></div>
    <button class="popsy-button-icon button small" (click)="close(true)">
      <popsy-icon-remove class="icon gray-dark" aria-hidden="true"></popsy-icon-remove>
    </button>
  </nav>
  @if (confirmationResult() === null) {
    <form (ngSubmit)="sendCodeWithPhoneNumber()">
      <h3 class="title">{{ t('title_welcome') }}</h3>
      <label
        ><h4>{{ t('hint_phone') }}</h4></label
      >
      <span class="fixed-space-8" aria-hidden="true"></span>

      <popsy-phone-input
        data-clarity-unmask
        [country]="defaultCountryCode()"
        [label]="t('label_phone')"
        [required]="true"
        [loading]="loading"
        (debouncedPhoneNumberChange)="onPhoneChange($event)"
        (errorChange)="onPhoneError($event)"></popsy-phone-input>

      <div aria-hidden="true" class="dynamic-space"></div>

      <button type="submit" class="popsy-button-primary" [disabled]="loading">
        <span>{{ t('action_continue') }}</span>
      </button>
    </form>
  }

  @if (confirmationResult() !== null) {
    <form (ngSubmit)="confirmCode()">
      <label
        ><h4>
          {{ t('title_sms_sent', { var1: getMaskedNumber() }) }}
        </h4></label
      >

      <popsy-lottie-animation
        class="animation slim"
        animation="permission-notification"></popsy-lottie-animation>

      <span class="fixed-space-8" aria-hidden="true"></span>

      <input class="otp" [formControl]="form" placeholder="123456" />

      <div aria-hidden="true" class="dynamic-space"></div>

      <button type="submit" class="popsy-button-primary" [disabled]="loading">
        <span> {{ t('action_next') }}</span>
      </button>
    </form>
  }

  @if (error !== null) {
    <div aria-hidden="true" class="dynamic-space"></div>

    <span class="small text-highlight">
      {{ error() }}
    </span>
  }

  <div
    #recaptchaContainer
    style="width: 0; height: 0; opacity: 0; position: absolute"></div>
</div>
